import { render, staticRenderFns } from "./LoadingAlert.vue?vue&type=template&id=edf81356&"
import script from "./LoadingAlert.vue?vue&type=script&lang=ts&"
export * from "./LoadingAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports